module.exports = __webpack_public_path__ + "static/neuro-psychology-room-mobile-a74892785e229803d21c9b4a558ae633.jpg";